import React, { FC, ReactElement } from 'react';
import { IconCont, SubmitInput } from './SubmitButton.styles';
import { BodyBoldS } from '../../styles/globals';

interface ISubmitButton {
  text: string;
  icon?: ReactElement;
}

const SubmitButton: FC<ISubmitButton> = ({ text, icon = null }) => (
  <SubmitInput data-testid="submit-button" type="submit">
    <IconCont>{icon}</IconCont>
    <BodyBoldS>{text}</BodyBoldS>
  </SubmitInput>
);

export default SubmitButton;
